import { render, staticRenderFns } from "./SuperClientesSelectComponent.vue?vue&type=template&id=b47c2272&"
import script from "./SuperClientesSelectComponent.vue?vue&type=script&lang=js&"
export * from "./SuperClientesSelectComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports